module.exports = __webpack_public_path__ + "static/media/pxiByp8kv8JHgFVrLGT9Z11lFd2JQEl8qw.79e6e81d.woff2";